import { Inject, Injectable, InjectionToken } from '@angular/core';
import { HttpInterceptor, HttpHandler, HttpRequest } from '@angular/common/http';
import { Observable, catchError, throwError, timeout } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import { AuthService } from '../shared/auth.service';

@Injectable()
export class AuthHttpInterceptor implements HttpInterceptor {
  refreshToken = false;

  constructor(
    private authService: AuthService,
    private toastr: ToastrService
  ) { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<any> {
    const user = this.authService.user;
    const userLoggedIn = this.authService.userLoggedIn;

    if (user && userLoggedIn) {
      const timeoutHeader = req.headers.get('timeout');
      const timeoutValue = timeoutHeader ? parseInt(timeoutHeader, 10) : 30000;

      const authReq = req.clone({
        setHeaders: {
          'userName': user.username,
          'password': user.password,
          'X-APP-ID': user.appId,
          'X-API-KEY': user.appKey
        },
      });

      return next.handle(authReq)
        .pipe(
          timeout(timeoutValue),
          catchError((err: any) => {
            console.warn('AuthHttpInterceptor ERROR: ', err);
            if (err.error && err.error.statusCode === 401) {
              this.authService.logout();
            }
            return throwError(err);
          })
        );
    }

    return next.handle(req.clone());
  }
}
